module.exports = __webpack_public_path__ + "img/certiUserIcon.54048c53.svg";